import { Button } from '../../../Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '../../../ui/dialog';

interface DiscardChangesDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DiscardChangesDialog({
  open,
  onConfirm,
  onCancel,
}: DiscardChangesDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <DialogContent className="max-w-md gap-6 rounded-xl border-seeker-800 bg-seeker-900 p-6 [&>button:last-child]:hidden">
        <div className="flex flex-col gap-1">
          <DialogTitle className="text-xl font-semibold leading-7">
            Discard changes?
          </DialogTitle>
          <DialogDescription className="text-sm text-seeker-400">
            This reverts your edits back to the currently published listing. It
            can&apos;t be undone.
          </DialogDescription>
        </div>
        <div className="flex flex-wrap gap-3">
          <Button
            variant="dangerOutline"
            className="w-[120px]"
            onClick={onConfirm}
          >
            Discard
          </Button>
          <Button
            variant="outlineMuted"
            className="w-[120px]"
            onClick={onCancel}
          >
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
